<div *ngIf="habilitar && faq != undefined" class="card card-visualizar-faq">
   <div class="row">
     <div class="col-md-10">
       <h3>{{faq.titulo}}</h3>
     </div>
     <div class="col-md-2 text-right">
       <i class="fa fa-close" (click)="fecharVisualizar()"></i>
     </div>
     <div class="col-md-12">
       <p [innerHTML]="faq.texto"></p>
     </div>
   </div>
</div>
